// extracted by mini-css-extract-plugin
export default {"wrapper":"SelectionContainer_wrapper__iPO8-"};